import { NOTIFICATION_BLOCK_EDITOR_REGISTRY } from './blockEditors';

// Notification.content is a JSON-serialized array of blocks (see
// notificationBlockTypes.js). parseNotificationContent is the one place
// that decides how to read a `content` string - used by both the builder
// (to load into the editable `blocks` array) and any read-only renderer.
// Falls back to wrapping a legacy plain string (the single-textarea shape
// this builder used before the block rework) as one `text` block, so the
// one real pre-existing Notification row keeps working untouched.
export function parseNotificationContent(content) {
   if (!content) return [];
   try {
      const parsed = JSON.parse(content);
      if (Array.isArray(parsed)) return parsed;
   } catch (e) { /* not JSON - legacy plain string, fall through */ }
   return [{ id: 1, type: 'text', text: content, align: 'left' }];
}

export function serializeNotificationBlocks(blocks) {
   return JSON.stringify(blocks);
}

// Read-only render of a full block array - used by the builder's preview
// pane. Each block type's own renderPreview (blockEditors.jsx) already
// handles its own empty-state, so this only needs to dispatch by type.
export function renderNotificationBlocks(blocks) {
   if (!blocks || blocks.length === 0) {
      return <span className='exercise-block-empty-hint'>Порожньо</span>;
   }
   return (
      <div className='communication-blocks-preview'>
         {blocks.map((block) => {
            const registryEntry = NOTIFICATION_BLOCK_EDITOR_REGISTRY[block.type];
            if (!registryEntry) return null;
            return <div key={block.id} className='communication-block-preview-item'>{registryEntry.renderPreview(block)}</div>;
         })}
      </div>
   );
}
